import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../components/common/Footer';

const PublicLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Note: Navbar is handled in AppRoutes.js globally, 
         so we don't include it here to avoid duplication. 
      */}

      {/* Main Content Area */}
      <main className="flex-grow">
        <Outlet />
      </main>

      {/* Footer appears at the bottom of all public pages */}
      <Footer />
    </div>
  );
};

export default PublicLayout;